// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".policy-dialog .el-dialog__header{padding:0}", "",{"version":3,"sources":["webpack://./resources/js/components/PolicyDialog.vue"],"names":[],"mappings":"AAAA,kCAAA,SAAA","sourcesContent":[".policy-dialog .el-dialog__header{padding:0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
